import { useCsAttribute } from "./useCsAttribute";
import { useLocalSelectState } from "./useLocalSelectState";
/**
 * Returns the currently selected value
 * - requires {@linkcode CsAttributeController}
 * @category Hook
 * @category CsAttribute
 * @export
 * @returns {string} Returns the empty string if no value is selected (empty option)
 */
export function useLocalSelectValue() {
    var _a;
    const attribute = useCsAttribute();
    const selectState = useLocalSelectState();
    const serverValue = (_a = attribute.values) === null || _a === void 0 ? void 0 : _a.find((value) => value.isSelected);
    const localValue = selectState[attribute.path];
    return localValue !== null && localValue !== void 0 ? localValue : serverValue === null || serverValue === void 0 ? void 0 : serverValue.value;
}
//# sourceMappingURL=useLocalSelectValue.js.map